import { c as _c } from "react-compiler-runtime";
import { useCallback, useRef } from 'react';
import { useObserverContext } from '../context/observerContext';
export const useObserveTableElementRef = () => {
  const $ = _c(2);
  const oldRef = useRef(null);
  const observer = useObserverContext();
  let t0;
  if ($[0] !== observer) {
    t0 = ref => {
      if (!observer) {
        return;
      }
      if (oldRef.current) {
        observer.unobserve(oldRef.current);
        oldRef.current = null;
      }
      if (!ref) {
        return;
      }
      observer.observe(ref);
      oldRef.current = ref;
    };
    $[0] = observer;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleRef = t0;
  return handleRef;
};